"use strict";
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TVA_UNIT = exports.StockManagementType = exports.RPD_UNIT = exports.PricerManagementType = exports.ProduitType = void 0;
var ProduitType;
(function (ProduitType) {
    ProduitType["PACK"] = "Pack";
    ProduitType["SINGLE"] = "SingleProduct";
})(ProduitType || (exports.ProduitType = ProduitType = {}));
var PricerManagementType;
(function (PricerManagementType) {
    PricerManagementType["PRICER"] = "pricer";
})(PricerManagementType || (exports.PricerManagementType = PricerManagementType = {}));
var RPD_UNIT;
(function (RPD_UNIT) {
    RPD_UNIT["UNIT"] = "\u20AC/unit";
    RPD_UNIT["KG"] = "\u20AC/kg";
    RPD_UNIT["L"] = "\u20AC/l";
    RPD_UNIT["T"] = "\u20AC/t";
})(RPD_UNIT || (exports.RPD_UNIT = RPD_UNIT = {}));
var StockManagementType;
(function (StockManagementType) {
    StockManagementType["STOCK_MANAGED"] = "managed";
    StockManagementType["STOCK_NOT_MANAGED"] = "notManaged";
})(StockManagementType || (exports.StockManagementType = StockManagementType = {}));
var TVA_UNIT;
(function (TVA_UNIT) {
    TVA_UNIT["POURCENT"] = "%";
})(TVA_UNIT || (exports.TVA_UNIT = TVA_UNIT = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9fdGVtcC9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsb0JBQW9CO0FBQ3BCLG9CQUFvQjtBQUNwQjs7Ozs7OztHQU9HOzs7QUE0UkgsSUFBWSxXQUdYO0FBSEQsV0FBWSxXQUFXO0lBQ3JCLDRCQUFhLENBQUE7SUFDYix1Q0FBd0IsQ0FBQTtBQUMxQixDQUFDLEVBSFcsV0FBVywyQkFBWCxXQUFXLFFBR3RCO0FBMmRELElBQVksb0JBRVg7QUFGRCxXQUFZLG9CQUFvQjtJQUM5Qix5Q0FBaUIsQ0FBQTtBQUNuQixDQUFDLEVBRlcsb0JBQW9CLG9DQUFwQixvQkFBb0IsUUFFL0I7QUFFRCxJQUFZLFFBS1g7QUFMRCxXQUFZLFFBQVE7SUFDbEIsZ0NBQWUsQ0FBQTtJQUNmLDRCQUFXLENBQUE7SUFDWCwwQkFBUyxDQUFBO0lBQ1QsMEJBQVMsQ0FBQTtBQUNYLENBQUMsRUFMVyxRQUFRLHdCQUFSLFFBQVEsUUFLbkI7QUFFRCxJQUFZLG1CQUdYO0FBSEQsV0FBWSxtQkFBbUI7SUFDN0IsZ0RBQXlCLENBQUE7SUFDekIsdURBQWdDLENBQUE7QUFDbEMsQ0FBQyxFQUhXLG1CQUFtQixtQ0FBbkIsbUJBQW1CLFFBRzlCO0FBRUQsSUFBWSxRQUVYO0FBRkQsV0FBWSxRQUFRO0lBQ2xCLDBCQUFjLENBQUE7QUFDaEIsQ0FBQyxFQUZXLFFBQVEsd0JBQVIsUUFBUSxRQUVuQiJ9